module.exports = __webpack_public_path__ + "img/bjear.6163ed8c.svg";